
import { EnumOpportunityType } from '../enum/enum-opportunity-type';
import {ClientInfos} from '../quote/client-informations';
import {QuoteWrapper} from '../quote/quote-wrapper';
import {ServiceProductLineMapper} from './service-product-line.mapper';

export class OpportunityContextModel {
    public opportunity: EforceOpportunityModel;
    public quoteToDuplicate: QuoteModel;
    public requestBy: RequestByModel;
    static populateQuoteWrapperWithContext( quoteWrapper: QuoteWrapper, context:OpportunityContextModel){
        return quoteWrapper.copyWith({
            eforceOpportunityId: context.opportunity.id,
            opportunityId: !(context.opportunity.id === quoteWrapper.eforceOpportunityId) ? null : quoteWrapper.opportunityId,
            opportunityLabel: context.opportunity.name,
            opportunityType: context.opportunity.type,
            clientInfos: new ClientInfos().copyWith({
                name: context.opportunity.account.name,
                contact: context.opportunity.account.contact,
                city: context.opportunity.account.city,
                phone: context.opportunity.account.phone,
                email: context.opportunity.account.email,
                market: context.opportunity.account.market,
                subMarket: context.opportunity.account.subMarket,
                accountElisId: context.opportunity.account.accountElisID
            }),
            regionCode: String(context.requestBy.user.regionCode),
            regionLabel: context.requestBy.user.regionName,
            teamCode: String(context.requestBy.user.teamCode),
            teamLabel: context.requestBy.user.teamName,
            speciality: context.requestBy.user.speciality,
            expectedProductLines: context.opportunity.productLines.map(pl =>  Object.setPrototypeOf(pl, ProductLineModel.prototype))
        });
    }
}

class EforceOpportunityModel {
    public id: string;
    public name: string;
    public type: EnumOpportunityType;
    public account: AccountModel;
    public contractId: string;
    public contractReference: string;
    public productLines: ProductLineModel[];
    public multisiteFramework: string;
}

export class ProductLineModel {
    public productLineCode: string;

    public isServiceCodeMatchProductLine(serviceCode: string): boolean {
        return ServiceProductLineMapper.isMatch(serviceCode, this.productLineCode);
    }

}

class QuoteModel {
    public id: string;
}

class AccountModel {
    public name: string;
    public contact: string;
    public city: string;
    public phone: string;
    public email: string;
    public accountElisID: string;
    public market: string;
    public subMarket: string;
}

class RequestByModel {
    public user: UserModel;
}

class UserModel {
    public email: string;
    public role: string;
    public speciality: string;
    public country: string;
    public regionCode: string;
    public regionName: string;
    public teamCode: string;
    public teamName: string;
    public phone: string;
}
